/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const defaultVideoThumbnail = {
  src: '/images/video-default-thumbnail-gray.svg',
  alt: 'defaultVideoThumbnail',
};
